export const batteryStatusStr = (batteryRemaining: number | null, isConnect: boolean) => {
  if (!isConnect || batteryRemaining === null) {
    return 'disconnected';
  }
  if (batteryRemaining > 60) {
    return '100';
  }
  if (batteryRemaining <= 60 && batteryRemaining > 30) {
    return '60';
  }
  if (batteryRemaining <= 30 && batteryRemaining > 8) {
    return '30';
  }
  if (batteryRemaining <= 8 && batteryRemaining > 3) {
    return '8';
  }
  return '3';
};
